module.exports = __webpack_public_path__ + "img/6.9516f125.jpg";